import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import UserProfileSearchableSelect from './UserProfileSearchableSelect';

export default function UserProfileFilterSelect({
  options = [],
  value,
  onChange,
  loading = false,
  disabled = false,
  sx,
}) {
  return (
    <Box sx={sx}>
      <UserProfileSearchableSelect
        options={options}
        value={value}
        onChange={onChange}
        loading={loading}
        disabled={disabled}
        label="Profile"
        placeholder="All profiles"
      />
    </Box>
  );
}

UserProfileFilterSelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
};
